import React from "react";
import { Link } from "react-router-dom";
import CompanyFilter from "../../../../core/common/crmComponents/CompanyFilter";
import CommonFilter from "../../../../core/common/crmComponents/filters/CommonFilter";
import ClearAllFilters from "../../../../core/common/crmComponents/filters/ClearAllFilters";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import ReloadButton from "../../../../core/common/crmComponents/ReloadButton";

const CardHeader = ({
  toggleLayout,
  layout,
  selectedCompany,
  setSelectedCompany,
}) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  return (
    <div className="card-header py-2">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
        {/* Left Section */}
        <div className="d-flex flex-wrap gap-3">
          <ReloadButton moduleName={MODULES.ACCOUNTS} />

          {/* Company Filter */}
          <CompanyFilter
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            user={user}
          />
        </div>

        {/* Right Section */}
        <div className="d-flex align-items-center gap-3">
          <div className="gap-1 d-flex align-items-center flex-wrap">
            <CommonFilter module={MODULES.ACCOUNTS} />
            <ClearAllFilters module={MODULES.ACCOUNTS} />
          </div>

          {/* Layout Toggle */}
          {/* <div className="view-icons d-flex gap-2">
            <Link
              to="#"
              className={`view-icon ${layout === "list" ? "active" : ""}`}
              onClick={() => toggleLayout("list")}
            >
              <i className="ti ti-list-tree" />
            </Link>
            <Link
              to="#"
              className={`view-icon ${layout === "grid" ? "active" : ""}`}
              onClick={() => toggleLayout("grid")}
            >
              <i className="ti ti-grid-dots" />
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CardHeader;
